const loadFacebookPixelScript = (): any => {
  return new Promise<void>((resolve) => {
    if (typeof window.fbq !== 'undefined') {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.async = true;
    script.onload = () => {
      const fbqFunction = (...args: any[]): void => {
        if (window.fbq.callMethod) {
          window.fbq.callMethod(...args);
        } else {
          window.fbq.queue?.push(args);
        }
      };
      window.fbq = fbqFunction;
      window.fbq.queue = [];
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.push = window.fbq;

      resolve();
    };

    document.head.appendChild(script);
  });
};

export default loadFacebookPixelScript;
